import { customFormat } from 'utilities/dateHelper'
import { DATE_FORMAT_API } from 'constants/index'

const FiltersParser = {
    parseFilters(immFilters){
        const result = {}
        immFilters.toSeq().forEach((v, k) => {
            switch (v.get('active') && v.get('filterType')) {
                case 'dateFilter':
                    result[`${k}To`] = customFormat(v.get('to'), DATE_FORMAT_API)
                    result[`${k}From`] = customFormat(v.get('from'), DATE_FORMAT_API)
                    break;
                case 'amountFilter':
                    result[`${k}To`] = v.get('to')
                    result[`${k}From`] = v.get('from')
                    break;
                case 'checkFilter':
                    result[k] = v.get('active')
                    break;
                case 'radioFilter':
                    result[k] = v.get('selected')
                    break;
                case 'selectorFilter':
                    result[k] = v.get('selected')
                    break;
                default:
                    break
            }
        })

        return result
    }
}

module.exports = FiltersParser;
